import React from "react";
import pathRoutes from "./pathRoutes";

const Guest = React.lazy(() => import("../utils/Guest"));
const LoginPage = React.lazy(() => import("../pages/general/LoginPage"));
const ChangePasswordPage = React.lazy(
  () => import("../pages/general/PasswordReset")
);
const ChangeResetPasswordForm = React.lazy(
  () => import("../pages/general/ResetPasswordForm")
);

const rootRoutes = [
  {
    path: "",
    element: (
      <Guest>
        <LoginPage />
      </Guest>
    ),
  },
  {
    path: pathRoutes.ROOT_PASSWORD_RESET,
    element: <ChangePasswordPage />,
  },
  {
    path: pathRoutes.ROOT_PASSWORD_RESET_FORM,
    element: <ChangeResetPasswordForm />,
  },
];

export default rootRoutes;
